import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


export type SelectInspectorFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectInspectorFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
    />

  );
};
